class ImpersonationService {
  constructor(httpDim, config, customerIntegrationsService, AuthenticationService){
    this.httpDim = httpDim;
    this.config = config;
    this.customerIntegrationsService = customerIntegrationsService;
    this.authenticationService = AuthenticationService;
  }

  impersonate(customerId){
    let customer = { customerId: customerId };
    return this.httpDim.put(this.config.apiRoot + '/impersonate', customer)
      .then(this.onImpersonateSuccess.bind(this))
      .then(this.updateIntegrationTypes.bind(this));
  }

  onImpersonateSuccess(response) {
    let token = response.data.token;
    this.setNewIdentity(token);
  }

  setNewIdentity(token) {
    this.authenticationService.setToken(token);
    this.authenticationService.setUserAccount(token);
    this.authenticationService.updateUserSessionSettings(token);
  }

  updateIntegrationTypes() {
    return this.customerIntegrationsService.setIntegrationTypes();
  }

  unimpersonate() {
    return this.httpDim.put(this.config.apiRoot + '/unimpersonate');
  }
}

ImpersonationService.$inject = ['httpDim', 'config', 'customerIntegrationsService', 'AuthenticationService'];

export default ImpersonationService;




// WEBPACK FOOTER //
// ./app/common/impersonation/impersonation.service.js